import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SelectedCurrency from '../SelectedCurrency'
import { Input as MuiInput } from '@material-ui/core'
import NumberFormatter from 'components/NumberFormatter'
import * as currencyActionCreators from 'core/actions/actions-currency'
import { styles } from './styles.scss'

class DepositLiquidityInputs extends Component {
	constructor(props) {
		super(props)			
			this.firstTokenInput = React.createRef()

			this.state = {
				tokenInputAmount0: "",
				tokenInputAmount1: ""
		}
	}

	handleChange = (evt) => {
		const { actions } = this.props
		const { name, value } = evt.target
		const tokenInput = name

		if(tokenInput === "input-token-0") {
			this.setState({ tokenInputAmount0: value })
			actions.currency.enterInputAmount("token0", value)
		} else if (tokenInput === "input-token-1") {
			this.setState({ tokenInputAmount1: value })
			actions.currency.enterInputAmount("token1", value)
		}
	}

	componentDidUpdate = () => {
		this.firstTokenInput.focus()
	}
	render() {
		const { actions, currency } = this.props
		const { 
			currency0,
			currency1,
			token0Amount,
			token1Amount,
			token0AmountUSD,
			token1AmountUSD
		} = currency

		return (
			<div className={styles}>
				<div className="token-input-amount">
					<MuiInput
						autoFocus
						className="input-field"
						disableUnderline
						// error={!!errorMsg}
						placeholder="0"
						classes={{
							focused: 'input-focused',
							error: 'input-error'
						}}
						name="input-token-0"
						actions={actions.currency}
						onChange={this.handleChange}
						inputComponent={NumberFormatter}
						value={token0Amount}
						inputRef={(input) => { this.firstTokenInput = input }}
					/>
					<span className="token-dollar-amount">
						{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(token0AmountUSD)}
					</span>
					<SelectedCurrency currency={currency0} />
				</div>
				<div className="token-input-amount">
					<MuiInput
						className="input-field"
						disableUnderline
						// error={!!errorMsg}
						placeholder="0"
						classes={{
							focused: 'input-focused',
							error: 'input-error'
						}}
						name="input-token-1"
						actions={actions.currency}
						onChange={this.handleChange}
						inputComponent={NumberFormatter}
						value={token1Amount}
					/>
						<span className="token-dollar-amount">
							{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(token1AmountUSD)}
						</span>
						<SelectedCurrency currency={currency1} />
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currency: state.currency
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: {
			currency: bindActionCreators(currencyActionCreators, dispatch)
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DepositLiquidityInputs)
